import React, { ReactElement, useRef, useState } from 'react';
import { Button, FormControl, InputGroup } from 'react-bootstrap';
import './CopyInput.scss';
import { spawn } from 'child_process';
import { CopyIcon } from '../../Icons';

function CopyInput({ value }) {
  const inputRef = useRef(null);

  const [buttonLabel, setButtonLabel] = useState<string | ReactElement>(<CopyIcon />);

  const copyToClipboard = () => {
    const input = inputRef.current;
    if (input && navigator.clipboard) {
      navigator.clipboard
        .writeText(input.value)
        .then(() => {
          setButtonLabel(<span className='copy-button'>Copied!</span>);
          setTimeout(() => setButtonLabel(<CopyIcon />), 3000);
        })
        .catch((err) => {
          console.error('Failed to copy text: ', err);
        });
    }
  };

  return (
    <InputGroup className='mb-3 custom-copy'>
      <FormControl ref={inputRef} value={value} className='custom-copy-input' readOnly />
      <Button variant='outline-secondary' id='button-addon2' onClick={copyToClipboard}>
        {buttonLabel}
      </Button>
    </InputGroup>
  );
}

export default CopyInput;
